import { SELECT_LEAGUES } from '../constants/actionTypes';
import { updateObject } from '../shared/utility';

const initialState={
    selectedLeagues:[],
    isFirstRender:true,
}

const selectLeagues=(state,action)=>{
    return updateObject(state,{selectedLeagues:action.leagues,isFirstRender:false});
}

const leagueReducer=(state=initialState,action)=>{
    switch(action.type){
        case SELECT_LEAGUES:
            return selectLeagues(state,action);
        default:
            return state;
    }
}

export default leagueReducer;